import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import accordionStyles from './accordionStyles';
import buttonStyles from './buttonStyles';
import drawerStyles from './drawerStyles';
import headingStyles from './headingStyles';
import linkStyles from './linkStyles';
import menuStyles from './menuStyles';
import dividerStyles from './dividerStyles';
import { useTokens } from '../context/TokenProvider';
import textStyles from './textStyles';
import vstackStyles from './vstackStyles';
import tabsStyles from './tabsStyles';
import tableStyles from './tableStyles';
import inputStyles from './inputStyles';
import formLabelStyles from './formLabelStyles';
import listStyles from './listStyles';
import modalStyles from './modalStyles';
import textAreaStyles from './textAreaStyles';
import checkboxStyles from './checkboxStyles';
import alertStyles from './alertStyles';
import tagStyles from './tagStyles';
import badgeStyles from './badgeStyles';
import imageStyles from './imageStyles';
import selectStyles from './selectStyles';
import containerStyles from './containerStyles';
import spinnerStyles from './spinnerStyles';
import tooltipStyles from './tooltipStyles';
import skeletonStyles from './skeletonStyles';
import popoverStyles from './popoverStyles';
import radioStyles from './radioStyles';
const ChakraThemeProvider = ({ children }) => {
    const tokens = useTokens();
    const theme = extendTheme({
        components: {
            Alert: alertStyles(tokens),
            Accordion: accordionStyles(tokens),
            Badge: badgeStyles(tokens),
            Button: buttonStyles(tokens),
            Image: imageStyles(tokens),
            Drawer: drawerStyles(tokens),
            Heading: headingStyles(tokens),
            Link: linkStyles(tokens),
            List: listStyles(tokens),
            Menu: menuStyles(tokens),
            Divider: dividerStyles(tokens),
            Text: textStyles(tokens),
            VStack: vstackStyles(tokens),
            Tabs: tabsStyles(tokens),
            Table: tableStyles(tokens),
            Input: inputStyles(tokens),
            FormLabel: formLabelStyles(tokens),
            Modal: modalStyles(tokens),
            Textarea: textAreaStyles(tokens),
            Checkbox: checkboxStyles(tokens),
            Tag: tagStyles(tokens),
            Select: selectStyles(tokens),
            Container: containerStyles(tokens),
            Spinner: spinnerStyles(tokens),
            Tooltip: tooltipStyles(tokens),
            Skeleton: skeletonStyles(tokens),
            Popover: popoverStyles(tokens),
            Radio: radioStyles(tokens),
        },
    });
    return React.createElement(ChakraProvider, { theme: theme }, children);
};
export default ChakraThemeProvider;
